import { EnumOption } from './enum-option';
import { createEnumOptions } from '../../shared/utils';

export enum FormDesignStatus {
  Draft = 0,
  Published = 1,
  Abandoned = 2
}

export const FormDesignStatusList: EnumOption[] = createEnumOptions(FormDesignStatus);
